import {
  createContext,
  FC,
  PropsWithChildren,
  useContext,
  useEffect,
  useMemo,
} from 'react';

import ServiceConfigKey from '../../constants/ServiceConfigKey';
import Loading from '../Loading';
import Maintenance from '../Maintenance';

import currencies from './currencies.json';
import { useCurrencyQuery } from './Currency.generated';

const defaultCurrency = 'USD';

export const CurrencyContext = createContext<string>(defaultCurrency);

export const useCurrency = (): [string, string] => {
  const currency = useContext(CurrencyContext);
  // TODO: Check why linting does not work
  // eslint-disable-next-line
  const symbol = currencies.find(({ code }) => code === currency)?.symbol as string | undefined;

  if (!symbol) {
    throw new Error('Unsupported currency');
  }

  return [currency, symbol];
};

const CurrencyProvider: FC<PropsWithChildren<unknown>> = ({ children }) => {
  const {
    previousData,
    data = previousData,
    loading,
    error,
  } = useCurrencyQuery();

  const currency = useMemo(
    () =>
      data?.serviceConfigs?.find(
        ({ key }) =>
          (key as unknown as ServiceConfigKey) === ServiceConfigKey.Currency,
      )?.value,
    [data?.serviceConfigs],
  );

  useEffect(() => {
    global.currency = currency || defaultCurrency;
  }, [currency]);

  if (error) {
    return <Maintenance />;
  }

  if (loading || !global.currency) {
    return <Loading />;
  }

  return (
    <CurrencyContext.Provider value={global.currency}>
      {children}
    </CurrencyContext.Provider>
  );
};

CurrencyProvider.displayName = 'CurrencyProvider';

export default CurrencyProvider;
